import { DEBUG_MODE } from '../enums';
import { $store } from './index';
import { debug } from '@/ts/utilities';

export class Channels {
    registry: Record<string, Array<Function>> = {};
    queue: Record<string, Array<Function>> = {};

    constructor() {
        $store.listen((state: Record<string, any>, oldState: object, changed: string) => {
            if (changed in this.registry) {
                this.registry[changed].forEach((callback: Function) => {
                    callback(state[changed]);
                });
            }
        });
    }

    register(id: string) {
        this.registry[id] = this.registry[id] || [];
        if (id in this.queue) {
            this.queue[id].forEach(callback => {
                this.attach(id, callback);
            });
            delete this.queue[id];
        }
    }

    attach(id: string, callback: Function) {
        if (id in this.registry) {
            this.registry[id].push(callback);
        } else {
            if (!(id in this.queue)) {
                this.queue[id] = [];
            }
            this.queue[id].push(callback);
            debug(`Queued request for ${id}`, DEBUG_MODE.WARNING);
        }
    }
}
